/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TaskStatesEnum = 'QUEUED' | 'IN_PROGRESS' | 'DONE' | 'FAILED' | 'CANCELING' | 'CANCELED';

export const TaskStatesEnum = {

    QUEUED: 'QUEUED' as TaskStatesEnum,

    IN_PROGRESS: 'IN_PROGRESS' as TaskStatesEnum,

    DONE: 'DONE' as TaskStatesEnum,

    FAILED: 'FAILED' as TaskStatesEnum,

    CANCELING: 'CANCELING' as TaskStatesEnum,

    CANCELED: 'CANCELED' as TaskStatesEnum
};

